module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("3.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('h3', {
    staticClass: "chaptitle"
  }, [_vm._v("IDENTITIES")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“We must educate ourselves about who we are, what our real identity is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("—Deepak Chopra")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "images",
      "src": "images/fig6.jpg"
    }
  })])]), _c('h3', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Identities that Carry Power & Privilege")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("These social identities are often defined by economic status, ethnicity, gender, religion, sexual orientation, and physical representation. These biological and cultural markers alone may afford someone more power and privilege than others. Advantages are given to certain folks who are perceived to be part of certain groups or societies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These inequitable advantages and distribution of power create exclusion, inequality, and disadvantages for some, while creating disproportionate advantages for others.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The identities associated with power and privilege move the tides of social reactions and treatment of various bodies and groups. In turn, these identities shape an individual’s perspectives on others and the world around them. Significantly, these concepts affect how someone moves around the world. For example, an affluent cis white male may navigate the work world differently than someone from a lower-income background who present as a Black trans woman.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These identities influence how we move, our body language, our biases, our thoughts, beliefs, emotions, expression of emotions, our relationship to emotions, our views on mental illness, poverty, health, wellness, and even what we view as necessities in life. Moreover, they affect how we hear what people are saying and how we communicate. Feelings of being misunderstood or devalued can easily become part of someone’s identity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These inequalities are the basis for much of today’s social justice work. Social justice is about creating allies and collaboration to promote equality, inclusion, respect, equity, and equal rights for all bodies in all social groups and communities.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Learning how to understand these identities and how to create a safe, understanding, and inclusive space for folks can be lifesaving. Giving folks a space to talk about themselves is as important as learning how to advocate for your needs in a way others can understand.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Identities More Burdened by Marginalization and Oppression")]), _vm._v(" "), _c('h3', {
    staticClass: "title1"
  }, [_vm._v("[Important: Related to Who We Might Consider More at Risk for Suicidal Thoughts, Gestures, Behavior]")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to the CDC, suicidal thoughts and behaviors are influenced by conditions a person experiences in their community. This includes work, home, play, or any setting that we inhabit. These conditions are sometimes referred to as social "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("determinants of health.")]), _vm._v(" They can include, but are not limited to, racism, prejudice, poverty, discrimination, housing insecurities, and barriers to education and/or healthcare. It can be lack of access to transportation, food insecurities, loss, unsafe spaces, fear of being unfairly accused, profiling, violence, rhetoric in the media, and lack of learning opportunities and tools. All these factors create more stress and feelings that can lead to suicidal thoughts or actions down the road.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Moreover, some communities have limited or no access to medical care, therapists, and other modalities of healthcare and healing. Because of these factors and other social conditions, some populations experience more of these issues than the general population. This directly correlates to higher rates of suicide and suicide attempts. The increased rates of various issues in some communities are sometimes referred to as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("health disparities.")]), _vm._v(" These populations include but are not limited ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("to veterans, LGBTQIA2S+ people, people living in rural areas, indigenous populations, BIPOC people, people with illness or disabilities, and middle-aged and older folks.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Suicide rates differ by job as well. Your job can also put you at higher risk. Many of these jobs are held by people without access to education or connections for upward mobility.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e28ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter03.vue
// module id = 87
// module chunks = 0